import * as React from 'react';
import cx from 'classnames';
import { createSvgIcon } from '../utils/createSvgIcon';
import { iconClassNames } from '../utils/iconClassNames';

export const TagIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg role="presentation" focusable="false" viewBox="2 2 16 16" className={classes.svg}>
      <g className={cx(iconClassNames.outline, classes.outlinePart)}>
        <path d="M13.999 7C14.5513 7 14.999 6.55228 14.999 6C14.999 5.44772 14.5513 5 13.999 5C13.4467 5 12.999 5.44772 12.999 6C12.999 6.55228 13.4467 7 13.999 7Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1282 2.00004C10.5942 1.99654 10.0809 2.20681 9.70272 2.58399L3.02118 9.24852C2.23844 10.0293 2.23763 11.297 3.01938 12.0788L7.96778 17.0271C8.74883 17.8082 10.0152 17.8082 10.7962 17.0271L17.427 10.3963C17.8028 10.0205 18.0136 9.51063 18.0128 8.97917L18.0055 4.02911C18.0039 2.93081 17.1169 2.0393 16.0186 2.0321L11.1282 2.00004ZM10.4089 3.29199C10.598 3.1034 10.8546 2.99827 11.1217 3.00002L16.0121 3.03208C16.5612 3.03568 17.0047 3.48143 17.0055 4.03058L17.0128 8.98065C17.0132 9.24637 16.9078 9.50133 16.7199 9.68923L10.0891 16.32C9.69857 16.7106 9.06541 16.7106 8.67488 16.32L3.72649 11.3716C3.33561 10.9808 3.33601 10.3469 3.72739 9.95653L10.4089 3.29199Z"
        />
      </g>
      <path
        className={cx(iconClassNames.filled, classes.filledPart)}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0055 4.03317C18.0039 2.93487 17.1169 2.04336 16.0186 2.03616L11.1282 2.0041C10.5942 2.0006 10.0809 2.21087 9.70272 2.58805L3.02118 9.25258C2.23844 10.0333 2.23763 11.3011 3.01938 12.0828L7.96778 17.0312C8.74882 17.8123 10.0152 17.8123 10.7962 17.0312L17.427 10.4004C17.8028 10.0246 18.0136 9.51468 18.0128 8.98323L18.0055 4.03317ZM13.999 7C14.5513 7 14.999 6.55228 14.999 6C14.999 5.44771 14.5513 5 13.999 5C13.4467 5 12.999 5.44771 12.999 6C12.999 6.55228 13.4467 7 13.999 7Z"
      />
    </svg>
  ),
  displayName: 'TagIcon',
});
